export type WeatherCondition = 'Clear' | 'Cloudy' | 'Rain' | 'Snow' | 'Wind' | 'Hot' | 'Fog';

export interface DailyReport {
  id?: number;
  projectId: number;
  reportDate: string;
  foremanName: string;
  weatherConditions: WeatherCondition | string;
  temperature: string;
  workersOnSite: number;
  hoursWorked: number;
  workCompleted: string;
  materialsUsed: string;
  issuesEncountered: string;
  safetyIncidents: string;
  requiresInspection: boolean;
  inspectionDetails: string;
  delaysOrSetbacks: string;
  nextDayPlan: string;
  createdAt?: string;
  updatedAt?: string;
}

export const WEATHER_CONDITIONS: WeatherCondition[] = [
  'Clear', 'Cloudy', 'Rain', 'Snow', 'Wind', 'Hot', 'Fog'
];
